import KineticTeamHybrid from '../components/ui/kinetic-team-hybrid';

const team = [
  {
    id: '01',
    name: 'Valentina Reyes',
    role: 'Directora Creativa',
    image:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face',
  },
  {
    id: '02',
    name: 'Santiago Herrera',
    role: 'Director de Estrategia',
    image:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face',
  },
  {
    id: '03',
    name: 'Camila Torres',
    role: 'Diseñadora de Marca',
    image:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=face',
  },
  {
    id: '04',
    name: 'Andrés Mendoza',
    role: 'Desarrollador Web',
    image:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
  },
  {
    id: '05',
    name: 'Isabella Navarro',
    role: 'Social Media Manager',
    image:
      'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop&crop=face',
  },
  {
    id: '06',
    name: 'Diego Ramírez',
    role: 'Director de Marketing',
    image:
      'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=face',
  },
];

export default function Team() {
  return (
    <div className="page">
      <KineticTeamHybrid team={team} />
    </div>
  );
}
